import { Content } from '../../types';

export const krabiContent: Content = {
  title: 'קראבי – פנינת טבע בדרום-מערב תאילנד',
  imageUrl: '/images/thailand/krabi/krabi-wide.jpeg',
  introduction:
    'קראבי הינו מחוז בדרום-מערב תאילנד, השוכן על חופו של ים אנדמן. זהו אחד מהיעדים הפופולריים ביותר במדינה, בזכות חופיו המרהיבים, תצורות הסלע הייחודיות שלו ואטרקציות טבע רבות המושכות מבקרים מכל רחבי העולם. המרכז העירוני של המחוז הינו העיר קראבי טאון, אך מרבית התיירים מתרכזים באזור החוף הפופולרי או נאנג (Ao Nang), הידוע בחיי הלילה התוססים, הטיילת היפה והשקיעות עוצרות הנשימה.',
  sections: [
    {
      title: 'נופי אבן הגיר – סימן ההיכר של קראבי',
      type: 'text',
      content:
        'קראבי ידוע בזכות תצורות אבן הגיר המרשימות שלו, הפזורות בכל רחבי המחוז – הן ביבשה והן בים. מדובר בצוקים גבוהים, מערות מרתקות עם ממצאים ארכיאולוגיים קדומים ואיים ציוריים המקנים לאזור נוף ייחודי ובלתי נשכח. חופי ריילי (Railay) ופראנאנג (Phra Nang) הם מהחופים היפים ביותר בתאילנד, ומציעים טבע פראי, מים צלולים וחול לבן רך.',
    },
    {
      title: 'אטרקציות מרכזיות במחוז קראבי',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'חופים מרהיבים',
          text: 'חופי ריילי, פראנאנג ואו נאנג, הינם מוקדי המשיכה המרכזיים עבור חובבי הים והנוף הטרופי.',
        },
        {
          subtitle:
            'בריכת האמרלד (Emerald Pool) והמעיינות החמים הטבעיים (Klong Thom Hot Springs)',
          text: 'טיול יום לאזורי מים טבעיים אלו הוא חוויה בלתי נשכחת, במיוחד בתוך היערות העבותים של קראבי.',
        },
        {
          subtitle: 'תצפית מקדש הנמר (Tiger Cave Temple)',
          text: 'מסלול מאתגר הכולל טיפוס של כ-1,200 מדרגות אל נקודת תצפית עוצרת נשימה על האזור.',
        },
        {
          subtitle: 'שייט לאי הונג (Hong Island)',
          text: 'אחד האיים היפים ביותר באזור, הכולל לגונה טבעית המוקפת בצוקים גבוהים.',
        },
        {
          subtitle: 'טיול ארבעת האיים',
          text: 'שייט יומי הכולל ביקור באיים הקסומים קאי (Koh Kai), מו (Koh Mo), פאד (Koh Poda) וטאפק (Koh Tap), הידוע בגשר החול הטבעי המחבר בין האיים.',
        },
        {
          subtitle: 'פארקים לאומיים',
          text: 'קראבי מתהדר במספר פארקים לאומיים מרשימים, בהם Than Bok Khorani ו-Khao Phanom Bencha, שבהם ניתן ליהנות ממפלים, בריכות טבעיות ויערות גשם.',
        },
        {
          subtitle: 'שיט קיאקים ביערות המנגרובים',
          text: 'חוויה אקולוגית ייחודית המאפשרת חקר של תעלות מים נסתרות וסביבות טבע מרתקות.',
        },
        {
          subtitle: 'טיפוס צוקים בחופי ריילי',
          text: 'יעד מועדף על חובבי טיפוס מכל העולם, הודות לצוקים המרשימים והנוף עוצר הנשימה.',
        },
      ],
    },
    {
      title: 'שווקי לילה וחוויות קולינריות',
      description:
        'לצד אטרקציות הטבע, קראבי מציעה גם חוויית קניות ובילוי אותנטית.',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'שוק הלילה של או נאנג',
          text: 'פועל בכל ימות השבוע ומציע מגוון רחב של אוכל רחוב תאילנדי, מזכרות וביגוד.',
        },
        {
          subtitle: 'שוק הלילה של קראבי טאון',
          text: 'פעיל בעיקר בסופי שבוע ומציע אווירה מקומית יותר עם דוכנים המוכרים מאכלים מסורתיים, אומנות מקומית ומוזיקה חיה.',
        },
      ],
    },
    {
      title: 'העונה הטובה ביותר לביקור בקראבי',
      type: 'text',
      content:
        'התקופה המומלצת ביותר לבקר בקראבי הינה העונה היבשה, הנמשכת מנובמבר עד אפריל. בעונה זו מזג האוויר נוח, הים רגוע והתנאים אידיאליים לשיט, שחייה וצילום נופים מרהיבים.',
    },
    {
      title: 'שילוב קראבי במסלול טיול בתאילנד',
      type: 'text',
      content:
        'רבים מהמטיילים משלבים את קראבי כחלק מטיול בדרום תאילנד, הכולל ביקור באיים נוספים כגון פוקט, קאו לאק וקאו סוק. ניתן להגיע לקראבי בטיסה ישירה מבנגקוק ו/ או טיסה לפוקט + העברה יבשתית/ ימית או באמצעות תחבורה יבשתית וימית ממקומות אחרים בתאילנד.',
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, קראבי הינו יעד חלומי לכל מי שאוהב חופים קסומים, טבע פראי ותרבות מקומית עשירה. עם שפע של אטרקציות, חוויות קולינריות ונופים עוצרי נשימה, זהו מקום שכדאי לכל מטייל בתאילנד לשלב במסלולו.',
    },
  ],
};
